var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("span", [_vm._v("Vendor Coverage")]),
      ]),
      _c("el-row", [
        _c(
          "div",
          { staticClass: "table-title" },
          [
            _vm._v(" " + _vm._s(_vm.inspTypeListTitle) + " "),
            _c(
              "el-button",
              {
                attrs: {
                  disabled: this.coverageListLoading,
                  type: "secondary",
                  size: "mini",
                },
                on: { click: _vm.toggleDisplay },
              },
              [_vm._v("Show/Hide")]
            ),
          ],
          1
        ),
        _vm.displayDiv
          ? _c(
              "div",
              [
                _c("InspectionTypesTable", {
                  attrs: {
                    list: _vm.inspTypeList,
                    listLoading: _vm.inspTypeListLoading,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.selectedId !== 0
        ? _c(
            "el-row",
            {
              staticStyle: {
                background: "#fff",
                padding: "16px 0px 0",
                "margin-bottom": "32px",
              },
            },
            [
              _c(
                "div",
                { staticClass: "table-title" },
                [
                  _vm._v(" " + _vm._s(_vm.coverageListTitle) + " "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: this.coverageListLoading,
                        type: "secondary",
                        size: "mini",
                      },
                      on: { click: _vm.handleRadius },
                    },
                    [_vm._v("Set Driving Distance")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: this.coverageListLoading,
                        type: "secondary",
                        size: "mini",
                      },
                      on: { click: _vm.handleAddCoverage },
                    },
                    [_vm._v("Add Coverage Area")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: this.coverageListLoading,
                        type: "primary",
                        size: "mini",
                      },
                      on: { click: _vm.saveAll },
                    },
                    [_vm._v("Save Changes")]
                  ),
                  _c("span", { staticStyle: { float: "right" } }, [
                    _vm._v(_vm._s(_vm.coverageTotal) + " items"),
                  ]),
                ],
                1
              ),
              _c("VendorCoveragesTable", {
                attrs: {
                  list: _vm.coverageList,
                  listLoading: _vm.coverageListLoading,
                },
                on: {
                  handleDelete: _vm.handleCoverageDelete,
                  handleDeleteMultiple: _vm.handleCoverageDeleteMultiple,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Geographic Area",
            visible: _vm.editCoverageDialogVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editCoverageDialogVisible = $event
            },
          },
        },
        [
          _c("EditCoverageDialog", {
            attrs: {
              value: _vm.editCoverage,
              "vendor-id": _vm.value.vendorId,
              dialogVisible: _vm.editCoverageDialogVisible,
              copyable: "",
              boxed: "",
            },
            on: { close: _vm.handleCoverageDialogClose },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Coverage Radius",
            visible: _vm.editRadiusDialogVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editRadiusDialogVisible = $event
            },
          },
        },
        [
          _c("EditRadiusDialog", {
            attrs: {
              value: _vm.editRadius,
              dialogVisible: _vm.editRadiusDialogVisible,
              copyable: "",
              boxed: "",
            },
            on: { close: _vm.handleRadiusDialogClose },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }